var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import V2Client from './v2/v2-client';
import HttpTransport from './v2/V2HttpClient';
var WixDataSchemas = /** @class */ (function () {
    function WixDataSchemas(httpRequest, signedInstance, 
    // ignored
    gridAppId, options) {
        this._mapDefaults = function (schema) {
            if (!schema.displayField) {
                if (schema.fields && schema.fields.title) {
                    schema.displayField = 'title';
                }
                else {
                    schema.displayField = '_id';
                }
            }
            return schema;
        };
        if (options === null || options === void 0 ? void 0 : options.client) {
            this._client = options.client;
        }
        else {
            this._client = new V2Client(new HttpTransport(httpRequest, signedInstance, options));
        }
    }
    WixDataSchemas.prototype.get = function (collectionName, options) {
        var _this = this;
        return this._client.get(collectionName, options)
            .then(function (schema) { return _this._mapDefaults(schema); });
    };
    WixDataSchemas.prototype.bulkGet = function (collectionIds, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!collectionIds || collectionIds.length === 0) {
                    return [2 /*return*/, {}];
                }
                return [2 /*return*/, this._client.bulkGet(collectionIds, options)
                        .then(function (schemas) { return _this._mapDefaultsForSchemas(schemas); })];
            });
        });
    };
    WixDataSchemas.prototype.list = function (options) {
        var _this = this;
        return this._client.list(options)
            .then(function (schemas) { return _this._mapDefaultsForSchemas(schemas); });
    };
    WixDataSchemas.prototype.save = function (collectionName, schema) {
        return this._client.save(collectionName, schema);
    };
    WixDataSchemas.prototype.create = function (collectionName, schema) {
        return this._client.create(collectionName, schema);
    };
    WixDataSchemas.prototype.update = function (collectionName, schema) {
        return this._client.update(collectionName, schema);
    };
    WixDataSchemas.prototype.remove = function (collectionName) {
        return this._client.remove(collectionName);
    };
    WixDataSchemas.prototype.restore = function (collectionName) {
        return this._client.restore(collectionName);
    };
    WixDataSchemas.prototype.createField = function (collectionName, fieldKey, fieldSpec) {
        return this._client.createField(collectionName, fieldKey, fieldSpec).then(this._mapDefaults);
    };
    WixDataSchemas.prototype.updateField = function (collectionName, fieldKey, fieldSpec) {
        return this._client.updateField(collectionName, fieldKey, fieldSpec).then(this._mapDefaults);
    };
    WixDataSchemas.prototype.deleteField = function (collectionName, fieldKey) {
        return this._client.deleteField(collectionName, fieldKey).then(this._mapDefaults);
    };
    WixDataSchemas.prototype._mapDefaultsForSchemas = function (schemas) {
        var _this = this;
        return Object.keys(schemas).reduce(function (mutated, key) {
            var value = schemas[key];
            mutated[key] = _this._mapDefaults(value);
            return mutated;
        }, {});
    };
    return WixDataSchemas;
}());
export default WixDataSchemas;
//# sourceMappingURL=wix-data-schemas.js.map